import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("hf_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 401 && localStorage.getItem("hf_token") && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("hf_token");
      window.location.href = "/login";
    }
    if (d === "password_change_required" && window.location.pathname !== "/change-password") {
      window.location.href = "/change-password";
    }
    return Promise.reject(err);
  }
);

export const errCode = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "validation_error";
  return "network_error";
};

export const download = async (url, filename, opts = {}) => {
  const res = await api.request({ url, responseType: "blob", ...opts });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
};
